export default "/profile/images/hero_crm-square.png?a4a4fabf46826ea9d574e718a2f16352";